import { render } from "./TemplateSeventeen.vue?vue&type=template&id=33ea88a8"
import script from "./TemplateSeventeen.vue?vue&type=script&lang=js"
export * from "./TemplateSeventeen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__